import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { batchDeleteProjects } from '@chegg-wt/core/state/projects/actions'
import { DELETE_PROJECT_MODAL } from '@chegg-wt/core/state/modals/constants'
import { AppState } from '@chegg-wt/core/state'
import { CancelIcon } from '@chegg-ui/theme'
import { useModalBehavior } from '@chegg-ui/modal/'
import { closeModal } from '@chegg-wt/core/state/modals/actions'
import { modalDataSelector } from '@chegg-wt/core/state/modals/selectors'
import { MODAL_CLOSE_BUTTON, MODAL_CONTENT, MODAL_WRAPPER } from '../testIds'
import * as Styled from '../styled'
import { ConfirmButton, CancelButton, Heading } from './styled'
import {
  DELETE_PROJECT_MODAL_TITLE_SINGLE,
  DELETE_PROJECT_MODAL_DESC_SINGLE,
  DELETE_PROJECT_MODAL_TITLE_MULTIPLE,
  DELETE_PROJECT_MODAL_DESC_MULTIPLE,
  DELETE_PROJECT_MODAL_ID,
} from './constants'
import {
  DELETE_PROJECT_MODAL_TITLE,
  DELETE_PROJECT_MODAL_DESC,
  DELETE_PROJECT_MODAL_CANCEL_BUTTON,
  DELETE_PROJECT_MODAL_CONFIRM_BUTTON,
} from './testIds'

export interface DeleteModalBaseProps {
  modalData: { ids: string[] }
  handleConfirm?: (projectIds: string[]) => void
  handleClose?: () => void
}

export const DeleteProjectModal: React.FunctionComponent<DeleteModalBaseProps> = ({
  modalData,
  handleConfirm,
  handleClose,
}) => {
  const title =
    modalData.ids.length > 1
      ? DELETE_PROJECT_MODAL_TITLE_MULTIPLE(modalData.ids.length)
      : DELETE_PROJECT_MODAL_TITLE_SINGLE

  const description =
    modalData.ids.length > 1
      ? DELETE_PROJECT_MODAL_DESC_MULTIPLE
      : DELETE_PROJECT_MODAL_DESC_SINGLE

  const { modalRef, onModalKeyDown } = useModalBehavior({
    isOpen: true,
    onClose: handleClose,
    id: DELETE_PROJECT_MODAL_ID,
  })

  return (
    <Styled.ModalWrapper
      backdrop
      show
      enableScroll={false}
      onBackdropClick={() => handleClose}
      renderBackdrop={() => <Styled.DefaultBackdrop />}
      data-test={MODAL_WRAPPER}
    >
      <Styled.PositioningWrapper
        onKeyDown={onModalKeyDown}
        ref={modalRef}
        id={DELETE_PROJECT_MODAL_ID}
      >
        <Styled.ModalContent fullMobileModal data-test={MODAL_CONTENT} maxWidth={null}>
          <Styled.Container>
            <Heading data-test={DELETE_PROJECT_MODAL_TITLE}>{title}</Heading>
            <Styled.Message data-test={DELETE_PROJECT_MODAL_DESC}>
              {description}
            </Styled.Message>
            <Styled.ButtonContainerResponsive>
              <ConfirmButton
                onClick={() => handleConfirm(modalData.ids)}
                data-test={DELETE_PROJECT_MODAL_CONFIRM_BUTTON}
              >
                Delete
              </ConfirmButton>
              <CancelButton
                onClick={handleClose}
                data-test={DELETE_PROJECT_MODAL_CANCEL_BUTTON}
              >
                Cancel
              </CancelButton>
            </Styled.ButtonContainerResponsive>
          </Styled.Container>
          <Styled.CloseButton
            screenReaderOnlyText="close modal"
            onClick={handleClose}
            data-test={MODAL_CLOSE_BUTTON}
          >
            <CancelIcon />
          </Styled.CloseButton>
        </Styled.ModalContent>
      </Styled.PositioningWrapper>
    </Styled.ModalWrapper>
  )
}

const mapStateToProps = (state: AppState) => ({
  modalData: modalDataSelector(state),
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleConfirm(projectIds: string[]) {
    dispatch(batchDeleteProjects({ ids: projectIds }))
  },
  handleClose() {
    dispatch(closeModal(DELETE_PROJECT_MODAL))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DeleteProjectModal)
